import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Tonnage } from '@classes/tonnage';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _moment from 'moment';
const moment = _moment;
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TonnageService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/tonnage';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getTonnages(starDate?: Date, endDate?: Date): Observable<Array<Tonnage>> {
    let params: any = {};
    if (starDate) {
      params.starDate = moment(starDate).format("YYYY-MM-DD");
    }
    if (endDate) {
      params.endDate = moment(endDate).format("YYYY-MM-DD");
    }
    return this.http.get<Array<Tonnage>>(this.basePath, {
      params: params
    });
  }

  createOrUpdateTonnage(tonnage?: Tonnage): Observable<Tonnage> {
    if (tonnage && tonnage.date instanceof Date) {
      tonnage.date = moment(tonnage?.date).format('YYYY-MM-DDTHH:mm')
    }
    if (tonnage?.id) {
      //update
      const url = `${this.basePath}/${tonnage?.id}`;
      return this.http.patch<any>(url,
        tonnage).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        tonnage
      ).pipe(map(m => {
        return m
      }));
    }
  }

  deleteTonnage(tonnageId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${tonnageId}`;
    return this.http.delete(url);
  }

}
